import React, { useState, useEffect } from 'react';
import FormStore from 'lib/stores/formStore';
import ModalStore, { closeModal } from 'lib/stores/modalStore';
import LoaderStore, { reset } from 'lib/stores/loaderStore';
import ValidationStore from 'lib/stores/validationStore';
import Modal from 'lib/components/Modal';

import PhotoForm from 'HostForms/Photo';

const PhotoModal = ({ page, subject = 'hosts' }) => {
  const form = (page && page.toLowerCase()) || 'photo';
  const [valid, setValid] = useState(false);
  const { open, data: { photo } } = ModalStore.useState(state => state.photoModal);
  const { photo: image = {} } = FormStore.useState(state => state);
  const editingPhoto = Object.keys(photo).length > 0;

  const closePhotoModal = () => {
    ModalStore.update(state => closeModal(state, 'photo', { photo: {} }));
  };

  const onAfterSubmit = () => {
    FormStore.update(state => { state.photo = { name: '', kind: '' }; });
    LoaderStore.update(reset);

    closePhotoModal();
  };

  useEffect(() => {
    const validations = ValidationStore.currentState[form];
    const isValid = editingPhoto ? !!image.kind : (!!image.kind && validations.image.valid);

    setValid(isValid);
  }, [image]);

  return (
    <Modal
      title={editingPhoto ? 'Editing Photo' : 'Add Photo'}
      onClose={closePhotoModal}
      open={open}
      name="Test"
      acceptMessage="Upload"
      disabled={!valid}
      id="photoModal"
      formId="photoForm"
    >
      <PhotoForm
        form={form}
        onAfterSubmit={onAfterSubmit}
        subject={subject}
        editingPhoto={editingPhoto}
      />
    </Modal>
  );
};

export default PhotoModal;
